import React, { useState } from 'react';

export default function Register({ onLoginLink }) {
  const [form, setForm] = useState({ email: '', password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [successEmail, setSuccessEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: form.email.trim().toLowerCase(),
          password: form.password,
          referral_source: (() => { try { return localStorage.getItem('ministry_ref') || undefined; } catch { return undefined; } })(),
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Registration failed. Please try again.');
      } else {
        setSuccessEmail(form.email.trim().toLowerCase());
        setSuccess(true);
        if (window.gtag) {
          window.gtag('event', 'conversion', { send_to: 'AW-17717407522' });
        }
      }
    } catch (err) {
      setError('Error connecting to the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <header className="py-6 px-8 border-b border-gray-100 bg-white">
          <h1 className="text-2xl font-bold" style={{ color: '#1B3A5C' }}>Ministry AI Toolkit</h1>
        </header>
        <main className="flex-1 flex items-center justify-center px-4 py-12">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md text-center">
            <div className="text-5xl mb-4">📬</div>
            <h2 className="text-2xl font-bold mb-2" style={{ color: '#1B3A5C' }}>Check Your Inbox!</h2>
            <p className="text-gray-500 text-sm mb-2">
              We've sent a confirmation email to:
            </p>
            <p className="font-semibold text-gray-800 mb-4">{successEmail}</p>
            <p className="text-gray-500 text-sm mb-6">
              Click the link in the email to activate your account. Check your spam folder if you don't see it.
            </p>
            <button
              onClick={onLoginLink}
              className="text-sm font-medium hover:underline"
              style={{ color: '#1B3A5C' }}
            >
              Back to Sign In
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="py-6 px-8 border-b border-gray-100 bg-white">
        <h1 className="text-2xl font-bold" style={{ color: '#1B3A5C' }}>Ministry AI Toolkit</h1>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md">
          <h2 className="text-2xl font-bold mb-2 text-center" style={{ color: '#1B3A5C' }}>Create Your Account</h2>
          <p className="text-gray-500 text-sm text-center mb-8">Get 5 free AI generations per month.</p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <input
                type="email"
                placeholder="pastor@church.org"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                placeholder="At least 8 characters"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
              <input
                type="password"
                placeholder="Re-enter your password"
                value={form.confirmPassword}
                onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-lg text-white font-semibold transition-opacity hover:opacity-90 disabled:opacity-60"
              style={{ backgroundColor: '#C8921A' }}
            >
              {loading ? 'Creating account...' : 'Create Account'}
            </button>
          </form>

          <p className="text-center text-sm text-gray-500 mt-6">
            Already have an account?{' '}
            <button
              onClick={onLoginLink}
              className="font-medium hover:underline"
              style={{ color: '#1B3A5C' }}
            >
              Sign in
            </button>
          </p>
        </div>
      </main>
    </div>
  );
}
